import { apiRequest } from "../client/apiClient";
import { retryRequest } from "../helpers/retryRequest";

export async function fetchUnits(searchString) {
  const endPoint = `/units${searchString ? `?${searchString}` : ``}`;
  return retryRequest(() => apiRequest(endPoint));
}

export async function saveUnit(unit) {
  return retryRequest(() =>
    apiRequest("/unit/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(unit),
    }),
  );
}

export async function editUnit(unit) {
  return retryRequest(() =>
    apiRequest(`/unit/edit/${unit.unitCode}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(unit),
    }),
  );
}
export async function deletUnit(unit) {
  return retryRequest(() =>
    apiRequest(`/unit/delete/${unit.unitCode}`, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
    }),
  );
}
